import { VK } from '@/define/define'
export interface color {
  r: number
  g: number
  b: number
  a: number
}
export interface point {
  x: number
  y: number
}

const defuleColor: color = { r: 0xef, g: 0x65, b: 0x69, a: 0xaa }
const defulePoint: point = { x: 0, y: 0 }
// const defuleAlign = "left" //left、right、center
const defuleSize = '12px'

class CapTextStyle {
  color = defuleColor
  size = defuleSize
  align = defulePoint
}
interface CapImage {
  src: string
  align: point
}
interface CapSide {
  text: string
  src: string
}
export interface Texture {
  text?: string
  style?: CapTextStyle
  image?: CapImage
  side?: CapSide
}
export const texture: { [index: VK]: Texture } = {
  8: {
    text: '←',
  } as Texture,
  9: {
    text: 'Tab',
  } as Texture,
  13: {
    text: 'Enter',
  } as Texture,
  19: {
    text: 'Pause',
  } as Texture,
  20: {
    text: 'Caps',
  } as Texture,
  24: {
    text: 'Fn',
  } as Texture,
  27: {
    text: 'ESC',
  } as Texture,
  32: {
    text: '—',
  } as Texture,
  33: {
    text: 'PgUp',
  } as Texture,
  34: {
    text: 'PgDn',
  } as Texture,
  35: {
    text: 'End',
  } as Texture,
  36: {
    text: 'Home',
  } as Texture,
  37: {
    text: '←',
  } as Texture,
  38: {
    text: '↑',
  } as Texture,
  39: {
    text: '→',
  } as Texture,
  40: {
    text: '↓',
  } as Texture,
  44: {
    text: 'Print',
  } as Texture,
  45: {
    text: 'Ins',
  } as Texture,
  46: {
    text: 'Del',
  } as Texture,
  48: {
    text: '0',
  } as Texture,
  49: {
    text: '1',
  } as Texture,
  50: {
    text: '2',
  } as Texture,
  51: {
    text: '3',
  } as Texture,
  52: {
    text: '4',
  } as Texture,
  53: {
    text: '5',
  } as Texture,
  54: {
    text: '6',
  } as Texture,
  55: {
    text: '7',
  } as Texture,
  56: {
    text: '8',
  } as Texture,
  57: {
    text: '9',
  } as Texture,
  65: {
    text: 'A',
  } as Texture,
  66: {
    text: 'B',
  } as Texture,
  67: {
    text: 'C',
  } as Texture,
  68: {
    text: 'D',
  } as Texture,
  69: {
    text: 'E',
  } as Texture,
  70: {
    text: 'F',
  } as Texture,
  71: {
    text: 'G',
  } as Texture,
  72: {
    text: 'H',
  } as Texture,
  73: {
    text: 'I',
  } as Texture,
  74: {
    text: 'J',
  } as Texture,
  75: {
    text: 'K',
  } as Texture,
  76: {
    text: 'L',
  } as Texture,
  77: {
    text: 'M',
  } as Texture,
  78: {
    text: 'N',
  } as Texture,
  79: {
    text: 'O',
  } as Texture,
  80: {
    text: 'P',
  } as Texture,
  81: {
    text: 'Q',
  } as Texture,
  82: {
    text: 'R',
  } as Texture,
  83: {
    text: 'S',
  } as Texture,
  84: {
    text: 'T',
  } as Texture,
  85: {
    text: 'U',
  } as Texture,
  86: {
    text: 'V',
  } as Texture,
  87: {
    text: 'W',
  } as Texture,
  88: {
    text: 'X',
  } as Texture,
  89: {
    text: 'Y',
  } as Texture,
  90: {
    text: 'Z',
  } as Texture,
  91: {
    text: 'Win',
  } as Texture,
  93: {
    text: 'Menu',
  } as Texture,
  96: {
    text: '0',
  } as Texture,
  97: {
    text: '1',
  } as Texture,
  98: {
    text: '2',
  } as Texture,
  99: {
    text: '3',
  } as Texture,
  100: {
    text: '4',
  } as Texture,
  101: {
    text: '5',
  } as Texture,
  102: {
    text: '6',
  } as Texture,
  103: {
    text: '7',
  } as Texture,
  104: {
    text: '9',
  } as Texture,
  105: {
    text: '9',
  } as Texture,
  106: {
    text: '*',
  } as Texture,
  107: {
    text: '+',
  } as Texture,
  109: {
    text: '-',
  } as Texture,
  110: {
    text: '.',
  } as Texture,
  111: {
    text: '/',
  } as Texture,
  112: {
    text: 'F1',
  } as Texture,
  113: {
    text: 'F2',
  } as Texture,
  114: {
    text: 'F3',
  } as Texture,
  115: {
    text: 'F4',
  } as Texture,
  116: {
    text: 'F5',
  } as Texture,
  117: {
    text: 'F6',
  } as Texture,
  118: {
    text: 'F7',
  } as Texture,
  119: {
    text: 'F8',
  } as Texture,
  120: {
    text: 'F9',
  } as Texture,
  121: {
    text: 'F10',
  } as Texture,
  122: {
    text: 'F11',
  } as Texture,
  123: {
    text: 'F12',
  } as Texture,
  144: {
    text: 'Num',
  } as Texture,
  145: {
    text: 'Scroll',
  } as Texture,
  160: {
    text: 'Shift',
  } as Texture,
  161: {
    text: 'Shift',
  } as Texture,
  162: {
    text: 'Ctrl',
  } as Texture,
  163: {
    text: 'Ctrl',
  } as Texture,
  164: {
    text: 'Alt',
  } as Texture,
  165: {
    text: 'Alt',
  } as Texture,
  186: {
    text: ';',
  } as Texture,
  187: {
    text: '+',
  } as Texture,
  188: {
    text: ',',
  } as Texture,
  189: {
    text: '-',
  } as Texture,
  190: {
    text: '.',
  } as Texture,
  191: {
    text: '?',
  } as Texture,
  192: {
    text: '~',
  } as Texture,
  219: {
    text: '[',
  } as Texture,
  220: {
    text: '|',
  } as Texture,
  221: {
    text: ']',
  } as Texture,
  222: {
    text: '"',
  } as Texture,
  253: {
    text: 'Enter',
  },
  250: {
    // mgx
    text: 'Fn',
  } as Texture,
}
export const defaultTexture = () => {
  return texture
}

export const defaultTextureWidth = new Map([
  ['ESC', 18],
  ['1!', 10],
  ['2@', 16],
  ['3#', 13],
  ['4$', 12],
  ['5%', 15],
  ['6^', 14],
  ['7&', 15],
  ['8*', 11],
  ['9(', 10],
  ['0)', 10],
  ['-_', 9],
  ['=+', 15],
  ['Backspace', 52],
  ['Tab', 18],
  ['Q', 8],
  ['W', 11],
  ['E', 6],
  ['R', 7],
  ['T', 6],
  ['Y', 6],
  ['U', 8],
  ['I', 3],
  ['O', 8],
  ['P', 7],
  ['[{', 8],
  [']}', 8],
  ['|', 3],
  ['CapsLock', 47],
  ['A', 8],
  ['S', 6],
  ['D', 8],
  ['F', 6],
  ['G', 8],
  ['H', 8],
  ['J', 5],
  ['K', 7],
  ['L', 5],
  [';:', 6],
  ['\'"', 8],
  ['Enter', 26],
  ['Shift', 24],
  ['Z', 7],
  ['X', 7],
  ['C', 7],
  ['V', 7],
  ['B', 7],
  ['N', 8],
  ['M', 10],
  [',<', 10],
  ['.>', 10],
  ['/?', 9],
  ['↑', 5],
  ['Del', 17],
  ['Ctrl', 18],
  ['Win', 20],
  ['Alt', 15],
  ['—', 11],
  ['Fn', 12],
  ['←', 10],
  ['↓', 5],
  ['→', 10],
  ['F1', 12],
  ['F2', 12],
  ['F3', 12],
  ['F4', 12],
  ['F5', 12],
  ['F6', 12],
  ['F7', 12],
  ['F8', 12],
  ['F9', 12],
  ['F10', 18],
  ['F11', 18],
  ['F12', 18],
  ['Ins', 15],
  ['PgUp', 27],
  ['PgDn', 27],
  ['`~', 11],
  ['Num', 25],
  ['/', 5],
  ['*', 5],
  ['-', 4],
  ['7', 6],
  ['9', 6],
  ['+', 8],
  ['4', 6],
  ['5', 6],
  ['6', 6],
  ['1', 6],
  ['2', 6],
  ['3', 6],
  ['0', 6],
  ['.', 3],
  ['Pause', 30],
  ['End', 18],
  ['Home', 22],
  ['Print', 25],
  ['Menu', 18],
  ['Scroll', 30],
])
// 检查 defaultTextureWidth 是否遗漏了 texture 中的 text
export const missingTextureWidth = Object.values(texture)
  .map((t) => t.text)
  .filter((text) => text && !defaultTextureWidth.has(text))
